import { V3MediaEditingModalContainer, V3MediaEditingModalContainerProps } from "../V3MediaEditingModal"

interface V3EditContentSEOProps extends Omit<V3MediaEditingModalContainerProps, "modalOpen" | "onCloseHandler"> {
    modalTitle?: string,
    SEOdescription?: string,
    modalOpen: boolean,
    setModalOpen: (open: boolean) => void,
}

export const V3EditContentSEO = ({
    modalTitle = "Edit content preview",
    SEOdescription = "Customize the preview of your portfolio",
    modalOpen,
    setModalOpen,
    ...rest
}: V3EditContentSEOProps) => <V3MediaEditingModalContainer
        {...rest}
        modalTitle={modalTitle}
        modalOpen={modalOpen}
        onCloseHandler={() => setModalOpen(false)}
        showMediaPreview
    />